<template>
  <div>
    <el-dialog
    fullscreen
    title='用户详情'
    :visible.sync="visible"
    :before-close="handleClose"
    :append-to-body="appendToBody?true:false"
    >
      <div class="container">
        <el-header class="basicHeader">

          <div class="headerCen">
            <div class="profile">
              <img :src="particulars.avatar" />
              <p>{{ particulars.nickName }}</p>
            </div>
            <div class="elemenbasic">
              <h4>姓名：{{ particulars.name }}</h4>
              <ul>
                <li>性别：{{ particulars.gender }}</li>
                <li>年龄：{{ particulars.age }}</li>
                <li>电话：{{ particulars.mobile }}</li>
              </ul>
            </div>
            <div class="recentData">
              <h4>
              最近数据：<span style="color: red;">{{ detail.humanClassifyName }}</span>
              </h4>
              <div class="recentCon">
                <ul>
                  <li>身高： {{ detail.weight.height }}CM</li>
                  <li>体重： {{ detail.weight.weight }}kg</li>
                  <li>BMI指数：{{ detail.weight.bmi }}</li>
                </ul>
                <ul>
                  <li>腰臀比：{{ detail.waistHipRatio.waisthipRatio }}</li>
                  <li>
                    血压：
                    {{
                      detail.bloodPressure.high +
                      "mmHg " +
                      detail.bloodPressure.low +
                      "mmHg"
                    }}
                  </li>
                  <li>血糖浓度： {{ detail.bloodSugar.bloodSugar }}mmol/L</li>
                </ul>
              </div>
            </div>
            <div class="btns">
              <el-button type="primary" @click="openPhysicalDialog">+新增体征</el-button>
              <el-button type="primary" @click="openExamineDialog">查看关键体征数据</el-button>
              <el-button type="primary" @click="openPunchCardDialog">查看打卡走势卡</el-button>
              <div class="label-action">
               <template v-for="(action,index) in actions">
                <div class="label-action-item" :key="'action'+index" @click="doAction(action)">{{action.title}}<div class="label-action-item-pot"></div></div>
               </template>
              </div>
              <div class="contact-button-wrapper">
                <div class="contact-button" @click="openContactDialog()"
                ><i style="margin-right: 2px;" class="el-icon-chat-dot-square"/>联系团队管理员</div>
                <div class="contact-button" @click="openContactDialog()"
                ><i style="margin-right: 2px;" class="el-icon-chat-dot-square"/>联系机构管理员</div>
               <!-- <div v-if="news.contactZXS" class="contact-button" @click="contact(user.doctorTypeE.ZXS)"
                ><i style="margin-right: 2px;" class="el-icon-chat-dot-square"/>联系{{user.doctorTypeE.ZXS_S}}</div>
               <div v-if="news.contactJGS" class="contact-button" @click="contact(user.doctorTypeE.JGS)"
                ><i style="margin-right: 2px;" class="el-icon-chat-dot-square"/>联系{{user.doctorTypeE.JGS_S}}</div>
                <div v-if="news.contactGLY" class="contact-button" @click="contact(user.doctorTypeE.GLY)"
                ><i style="margin-right: 2px;" class="el-icon-chat-dot-square"/>联系{{user.doctorTypeE.GLY_S}}</div> -->
              </div>
              
            </div>
          </div>
          <div class="headerBot">
            <el-tabs v-model="activeName" @tab-click="handClick">
              <el-tab-pane
                :label="item.label"
                :name="item.name"
                v-for="(item, index) in paneData"
                :key="index"
              ></el-tab-pane>
            </el-tabs>
          </div>
        </el-header>
        <el-main v-if="showRouterView">
          <router-view></router-view>
        </el-main>
      </div>
    </el-dialog>
    <addPhysicalDialog
      :visible="addPhysicalData.visible"
      :user="user"
      @close="closePhysicalDialog"
    ></addPhysicalDialog>
    <examineDialog
      :visible="examineData.visible"
      :user="user"
      @close="closeExamineDialog"
    ></examineDialog>
    <punchCardDialog @close="punchCardClose"  :user="user" :visible="punchCard.visible"/>
  </div>
  <!-- <ExamineDialog/> -->
</template>
<script>
import { api } from "@/request/api";
import addPhysicalDialog from "./info-dialog/add-physical-dialog.vue";
import examineDialog from "./info-dialog/examine-dialog.vue";
import punchCardDialog from "./info-dialog/punchCard-dialog.vue";
export default {
  props: ["visible","user","appendToBody","pathPre"],
  components: {
    addPhysicalDialog,
    examineDialog,
    punchCardDialog
  },
  data() {
    return {
      showRouterView:true,
      originalRoute:{},
      particulars: {},
      detail: {
        weight: {},
        waistHipRatio: {},
        bloodPressure: {},
        bloodSugar: {},
        generateTime:'',
      },
      addPhysicalData:{
        visible:false,
       
      },
      examineData:{
        visible:false,
       
      },
      contact:{
        receiverId:"",
        relatedUserId:""
      },
      news:{
        receiverId:"",
        relatedUserId:""
      },
      punchCard:{
        visible:false
      },
      actions:[
        {title:"消息",id:"xx"},
        {title:"方案",id:"fa"},
        {title:"预警",id:"warning"},
        {title:"饮食",id:"ys"}
      ],
      activeName: "",
      paneData: [],
      paneData1: [
        {
          label: "基本信息",
          name: "/infobot",
        },
        {
          label: "生化指标",
          name: "/shzb",
        },
        {
          label: "营养膳食",
          name: "/yyss",
        },
        {
          label: "人体成分",
          name: "/rtcf",
        },
        {
          label: "中医",
          name: "/zyzd",
        },
        {
          label: "睡眠监测",
          name: "/smjc",
        },
        {
          label: "心理",
          name: "/xlzd",
        },
        {
          label: "大脑",
          name: "/dnzt",
        },
        {
          label: "体检报告",
          name: "/tjbg",
        },
        {
          label: "辅助诊断报告",
          name: "/fzzdbg",
        },
        {
          label: "功能医学报告",
          name: "/znyxbg",
        },
        {
          label: "专属方案",
          name: "/zsfa",
        },
        {
          label: "营养素方案",
          name: "/yysfa",
        },
      ],
      paneData2: [
        {
          label: "基本信息",
          name: "/infobot",
        },
        {
          label: "生化指标",
          name: "/shzb",
        },
        {
          label: "营养膳食",
          name: "/yyss",
        },
        {
          label: "人体成分",
          name: "/rtcf",
        },
        {
          label: "中医",
          name: "/zyzd",
        },
        {
          label: "睡眠监测",
          name: "/smjc",
        },
        {
          label: "心理",
          name: "/xlzd",
        },
        {
          label: "大脑",
          name: "/dnzt",
        },
        {
          label: "体检报告",
          name: "/tjbg",
        },
        {
          label: "辅助诊断报告",
          name: "/fzzdbg",
        },
        {
          label: "功能医学报告",
          name: "/znyxbg",
        },
        {
          label: "专属方案",
          name: "/zsfa",
        },
        {
          label: "营养素方案",
          name: "/yysfa",
        },
      ],
      paneData3: [
        {
          label: "基本信息",
          name: "/infobot",
        },
        {
          label: "生化指标",
          name: "/shzb",
        },
        {
          label: "营养膳食",
          name: "/yyss",
        }
      ],
    };
  },
  created() {
    var that=this;
    that.$watch('user', function() {
      console.log('userbasic',that.user);
      if(this.user){
        that.showRouterView=true;
        that.originalRoute=that.$router.currentRoute;
        console.log('that.originalRoute',that.originalRoute);
        that.paneData = that.paneData2;
        that.jkdaparticulars();
        if(!that.activeName)that.activeName=that.paneData[0].name;
        that.$router.push({path:that.pathPre+that.activeName,query:{
        userId:that.user.id
        }});
        console.log('that.$router',that.$router);
      }
      
    });

  },
  methods: {
    openPunchCardDialog(){
      this.punchCard.visible=true;
    },
    punchCardClose(){
      this.punchCard.visible=false;
    },
    handleClose: function () {
      var that=this;
      that.activeName='';
      that.$emit('close');
      that.showRouterView=false;
      that.$nextTick(function () {
        that.$router.push({ path: that.originalRoute.fullPath });
      })
    },
    openPhysicalDialog(){
      var that=this;
      that.addPhysicalData.visible=true;
      
    },
    openExamineDialog(){
      var that=this;
      that.examineData.visible=true;
      
    },
    closePhysicalDialog() {
      //传值
      this.addPhysicalData.visible = false;
      
      this.jkdaparticulars();
    },
    closeExamineDialog() {
      //传值
      this.examineData.visible = false;
      
    },
    openContactDialog(){
       var that=this;

       that.contact.relatedUserId=that.particulars.id;
       that.notificationCenter.postNotificationName('openNewsDailog',that.contact);
    },
    doAction(action){
      if(action.id=='fa'){
        this.notificationCenter.postNotificationName('openZsfaRecordListDialog',{userId:this.user.id});
      }
      else if(action.id=='warning'){
        this.notificationCenter.postNotificationName('openWarningRecordListDialog',{userId:this.user.id});
      }
      else if(action.id=='ys'){
        console.log('openDietRecordListDialog',this.user.id);
        this.notificationCenter.postNotificationName('openDietRecordListDialog',{userId:this.user.id});
      }
      else if(action.id=='xx'){
        this.notificationCenter.postNotificationName('openNewsDailog',{userId:this.user.id});
      }
    },
    handClick(tab) {
      //标签切换
      console.log('this.pathPre+tab.name',this.pathPre+tab.name);
      this.$router.push({path:this.pathPre+tab.name,query:{
      userId:this.user.id
      }});
    },
    jkdaparticulars() {

      var that = this;
      var parameter = {
        userId: that.user.id,
      };


        api.jkdaparticulars(parameter).then((response) => {
          response = response.data;
          if (response.code == 0) {
            that.particulars = response.data;

          }
      });
      api.jkdadetail(parameter).then((response) => {
        response = response.data;
        if (response.code == 0) {
          if(response.data.generateTime)
          {
            var date = new Date(response.data.generateTime.iphoneDateFormat());
            response.data.generateTime=date.format("yyyy年MM月dd日");
          }

          that.detail = response.data;

        }
      });
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.el-main {
  margin: 20px 20px;
  padding: 0;
  box-shadow: none;
  border-radius: 4px;
  background: #f3f5f8;
}
.container{
 padding:20px 0px;
 background:#f5f5f6;
}
@185AD6: #185ad6;
.basicHeader {
  font-size: 16px;
  background-color: #fff;
  position: relative;
  .headerCen {
    display: flex;
    padding-bottom: 30px;
    padding-top: 30px;
    align-items: center;
    .profile {
      flex-basis: 10%;
      height: 130px;
      text-align: center;
      border-right: 1px solid #e3e3e3;
      img {
        width: 40px;
        height: 40px;
        margin: 30px 0 20px;
      }

    }
    .elemenbasic {
      flex-basis: 20%;
      padding-left: 28px;
      border-right: 1px solid #e3e3e3;
      li {
        padding-top: 10px;
      }
    }
    .recentData {
      display: flex;
      flex-basis: 50%;
      flex-direction: column;
      padding-left: 30px;
      border-right: 1px solid #e3e3e3;
      h4 span {

        font-weight: normal;
      }
      .recentCon {
        display: flex;
        ul{
          flex:1;
        }
        li {

          padding-top: 10px;
        }
      }
    }
    .btns {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      .el-button {
        width: 160px;
        text-align: center;
        margin-bottom:10px;
        font-size: 16px;
      }
    }
  }
}
.contact-button-wrapper{
  display: flex;
    justify-content: space-around;

    width: 100%;
}
.contact-button{
  font-size: 11px;
font-family: SourceHanSansCN-Normal, SourceHanSansCN;
font-weight: 400;
color: rgba(0, 0, 0, 0.85);
display: flex;
    align-items: center;
}
.contact-button:hover{
  color:#185AD6;
  cursor:pointer;
}
/deep/ .el-tabs__nav-wrap::after {
  background-color: #fff;
}
/deep/ .el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs__active-bar {
  background-color: @185AD6;
}
/deep/ .el-tabs__item.is-active {
  color: @185AD6;
}
/deep/.el-button+.el-button
{
  margin:0;
}
.label-action{
  display: flex;
  align-items: center;
  justify-content: center;
  
}
.label-action-item{
  
}
.label-action-item{
 position: relative;
 padding: 4px;
}
.label-action-item-pot{
  background: red;
    width: 4px;
    height: 4px;
    border-radius: 2px;
    position: absolute;
    top: 4px;
    right: 4px;
}
</style>
